import React, { Component, PropTypes } from 'react'
import cx from 'classnames'

import './AvailabilityCalendarTimeSlot.scss'

class AvailabilityCalendarTimeSlot extends Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick () {
    const {
      onClick,
      date
    } = this.props

    onClick(date)
  }

  render () {
    const {
      date,
      selected,
      available
    } = this.props

    const className = cx({
      'AvailabilityCalendarTimeSlot': true,
      'AvailabilityCalendarTimeSlot--disabled': !available,
      'AvailabilityCalendarTimeSlot--selected': selected
    })

    const disabled = !available || selected

    const displayFormat = 'kk:mm'
    const time = date.format(displayFormat)

    return (
      <button
        className={className}
        onClick={this.handleClick}
        disabled={disabled}
        >
        {time}
      </button>
    )
  }
}

AvailabilityCalendarTimeSlot.displayName = 'AvailabilityCalendarTimeSlot'
AvailabilityCalendarTimeSlot.propTypes = {
  date: PropTypes.object.isRequired, // Moment object
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  available: PropTypes.bool
}
AvailabilityCalendarTimeSlot.defaultProps = {
  selected: false,
  available: true
}

export default AvailabilityCalendarTimeSlot



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/AvailabilityCalendarPage/components/AvailabilityCalendarDay/components/AvailabilityCalendarTimeSlot/AvailabilityCalendarTimeSlot.js